export default {
  hzmbG: {
    title: {
      hzmbG: "香港貨車\n停泊澳門跨境貨物轉運站",
      application: "申請信息",
      vehicle: "車輛信息",
      owner: "車主信息",
      drivers: "駕駛員信息",
      driversIndex: "第{0}駕駛人",
      cancelDescription: "取消說明",
      auth: "身份驗證",
    },
    label: {
      registrationNo: "香港車輛登記號碼",
      identificationNo: "車身底盤號碼",
      mobile: "車主的流動電話(用於短訊通知)",
      mobileAreaCode: "區號",
      mobiltTips: "查詢編號將以短訊及電郵發出，請確保相關資訊無誤。",
      validType: "驗證類型",
      approveNo: "澳門批准編號",
      identificationNoLast4: "車身底盤號碼的最後4個字元",
      registerType: "登記類型",
      identType: "申請人身份證明文件種類",
      identNo: "申請人身份證明文件號碼",
      companyRegistrationType: "公司登記種類",
      companyRegistrationNo: "公司登記號碼",
      mainlandRegistrationNo: "內地車輛登記號碼",
      registrationType: "香港車輛登記類別",
      factory: "廠名",
      modelType: "型號",
      buildYear: "製造年份",
      firstRegisterDate: "首次登記日期",
      color: "顏色",
      driverSeat: "駕駛座位置",
      passengerCount: "核載人數(司機除外)",
      engineNo: "引擎號碼",
      permitWeight: "許可車輛總重",
      licenseExpireDate: "香港車輛牌照到期日",
      mainlandInsuranceNo: "內地保險單編號",
      mainlandInsuranceStartDate: "內地保險單生效日期",
      mainlandInsuranceEndDate: "內地保險單結束日期",
      ownerNameEn: "車主英文姓名",
      identityType: "身份證明文件種類",
      identityNo: "身份證明文件號碼",
      address: "住址",
      ownerCompanyNameEn: "公司英文名稱",
      companyIdentityType: "公司註冊證種類",
      companyRegisterNo: "公司註冊證號碼",
      companyAddress: "公司地址",
      macauMobile: "聯絡電話",
      email: "電郵地址",
      driverNameEn: "英文姓名",
      hongKongDrivingLicenseType: "香港駕駛執照類別(准駕車型)",
      hongKongDrivingLicenseNo: "香港駕駛執照號碼",
      birthday: "出生日期",
      sex: "性別",
      nationality: "國籍",
      cancelReason: "取消原因",
      mainlandDrivingFileNo: "內地駕照許可檔案編號",
      mainlandDrivingLicenseNo: "內地駕照編號",
      personal: "個人",
      company: "公司"
    },
    message: {
      registrationNo: "請輸入香港車輛登記號碼",
      identificationNo: "請輸入車身底盤號碼",
      mobile: "請輸入車主的流動電話(用於短訊通知)",
      vcode: "請先進行安全驗證",
      approveNo: "請輸入澳門批准編號",
      identificationNoLast4: "請輸入車身底盤號碼的最後4個字元",
      registerType: "請輸入登記類型",
      identNo: "請輸入身份證明文件號碼",
      companyRegistrationNo: "請輸入公司註冊證號碼",
      mainlandRegistrationNo: "請輸入內地車輛登記號碼",
      registrationType: "請輸入香港車輛登記類別",
      factory: "請輸入廠名",
      modelType: "請輸入型號",
      buildYear: "請輸入製造年份",
      firstRegisterDate: "請輸入首次登記日期",
      color: "請輸入顏色",
      driverSeat: "駕駛座位置",
      engineNo: "請輸入引擎號碼{0}",
      permitWeightTable: {
        title: "根據本澳現行法例，對於車輛的總重量有以下限制：",
        type: "車輛類別",
        weight: "總重量限制",
        two: "兩軸",
        three: "三軸",
        four: "四軸",
        fiveOrMore: "五軸或以上",
        type1: "僅車輛",
        type2: "牽引車及半掛車之組合",
        type3: "車輛及掛車之組合",
      },
      vehicleType: "車輛類別",
      vehicleType1: "僅車輛",
      vehicleType2: "牽引車及半掛車之組合",
      vehicleType3: "車輛及掛車之組合",
      permitWeight: "請輸入許可車輛總重",
      ton: "噸",
      permitWeightTip1: "單軸限重10噸",
      permitWeightTip2: "二軸限重16噸",
      permitWeightTip3: "三軸或以上限重22噸",
      permitWeightFloat: "最多保留一位小數",
      permitWeightMax: "請輸入正確的許可車輛總重",
      licenseExpireDate: "請輸入香港車輛牌照到期日",
      vehicleSize: {
        title: "使用澳門境外轉運站的香港貨車不得超過以下之車身最大尺碼：",
        max: "最大尺碼限制",
        length: "長",
        weight: "寬",
        height: "高 (自地面算起)",
      },
      mainlandInsuranceNo: "請輸入內地保險單編號",
      mainlandInsuranceStartDate: "請輸入內地保險單生效日期",
      mainlandInsuranceEndDate: "請輸入內地保險單結束日期",
      ownerNameEn: "請輸入車主英文姓名",
      nameEnChcek: "只可填寫英文字母，字符",
      company_nameEnChcek: "只可填寫英文字母，數字，字符",
      identityNoCheck: "只可填寫英文字母，數字",
      identityType: "請輸入身份證明文件種類",
      identityNo: "請輸入身份證明文件號碼",
      address: "請輸入住址",
      ownerCompanyNameEn: "請輸入公司英文名稱",
      companyIdentityType: "請輸入公司註冊證種類",
      companyRegisterNo: "請輸入公司註冊證號碼",
      companyAddress: "請輸入公司地址",
      macauMobile: "請輸入聯絡電話",
      email: "請輸入電郵地址",
      email_confirm: "請再次輸入電郵地址",
      emial_confirm_tip: "請確保兩次輸入的電郵地址一致",
      driverNameEn: "請輸入英文姓名",
      hongKongDrivingLicenseType: "請輸入香港駕駛執照類別(准駕車型)",
      hongKongDrivingLicenseNo: "請輸入香港駕駛執照號碼",
      hongKongDrivingLicenseNoCheck: "只可填寫英文字母，數字及“/”",
      birthday: "請輸入出生日期",
      sex: "請輸入性別",
      nationality: "請輸入國籍",
      agreeVehicleSize: "知悉及承諾使用澳門境外轉運站的香港貨車不得超過以上之車身最大尺碼",
      checkTips: "查詢編號將以短訊及電郵發出，請確保相關資訊無誤。",
      mainlandDrivingFileNo: "請輸入內地駕駛許可檔案編號",
      mainlandDrivingLicenseNo: "請輸入內地駕駛執照編號",
      driversIdentityNo: "如為內地駕駛員，請輸入往來港澳通行證編號",
    },
    enum: {
      areas: {
        macau: "澳門 +853",
        hongkong: "香港 +852",
        mainland: "内地 +86"
      },
      registerType: {
        PERSON: "以個人作登記",
        COMPANY: "以公司/單位作登記",
      },
      driverSeat: {
        E: "左盤",
        D: "右盤",
      },
      hkVehicleRegisterType: {
        LIGHT_TRUCK: "輕型貨車",
        MEDIUM_TRUCK: "中型貨車",
        HEAVY_TRUCK: "重型貨車",
        TRACTOR: "拖頭",
        TOW_TRUCK: "拖車",
      },
      cancelReasons: {
        PRIVATE_CANCEL_REASON: "因私人原因",
        COMPANY_CANCEL_REASON: "因公司決定",
        OTHER_CANCEL_REASON: "其他"
      }
    },
    success: {
      title: "辦理成功",
      applicationNo: "申請編號：",
    },
    terms_hzmbG_first:"<p>" +
    "  1. 應遵事項" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>每一申請均可配備不多於三名指定駕駛員，指定駕駛員須持有由香港當局發出的相關有效香港商用車輛駕駛執照。</li>" +
    "  <li>獲發許可後，如需更換使用許可的車輛（下稱“許可車輛＂）或車輛註冊號碼，必須致函交通事務局註銷舊登記後重新申請。</li>" +
    "  <li>許可不得轉讓，如車輛所有人在許可有效期內更改為另一所有人（許可持有人不再是許可車輛的所有人），有關許可將會被取消。</li>" +
    "  <li>許可車輛須為許可持有人/公司在香港註冊登記為輕型貨車、中型貨車、重型貨車、拖頭或拖架，且符合澳門《道路交通規章》所限制貨車的長、寛、總重量規定、高度不超過4.6米；許可持有人/公司亦必須確保許可車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
    "  <li>許可車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，許可車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
    "  <li>具備有效許可、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的許可車輛，可由持有有效香港商用車輛駕駛執照的指定駕駛員駕駛車輛經大橋前往澳門口岸跨境貨物轉運站運作，任何人須自行對因其自身、內地或香港的原因導致其許可車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
    "  <li>許可持有人、指定駕駛員或許可車輛如違反申領許可及港澳有關牌證的條款，其有關許可及牌證可被取消，其牌證及許可申請亦將不予受理。如許可、牌證或入境資格被取消，相應的牌證及許可亦可被取消。</li>" +
    "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其相關牌證及許可可被取消，其牌證及許可申請亦將不予受理。</li>" +
    "  <li>如發現許可持有人或指定駕駛員曾利用許可車輛進行走私、運送他人偷越邊境、非法營運（包括“白牌車”）、違規攜帶禁止或限制進出境物品、未申報應實施檢驗檢疫的行李或貨物等違法活動，該車輛相應的許可可被取消。</li>" +
    "  <li>申請人及許可持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則其申請將不予受理或其許可可被取消。</li>" +
    "  <li>如許可車輛無正當理由逾期離澳，自離澳或查實確認之日起計30日後將被暫停預約15日。</li>" +
    "  <li>如發現許可車輛曾超出通行區、通行條件或並非由指定駕駛員駕駛，其許可可被取消。</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  2. 個人資料的保護" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
    "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
    "  <li>申請人提供的所有個人資料，將按照澳門特別行政區第 8/2005 號法律《個人資料保護法》的規定進行處理，本局於審查文件時遇有疑問，有關資料可能會送交予有權 限機構作驗證或查詢。申請人依法享有資訊權、查閱權、更正權及反對權，在行使有關權利時，必須以書面方式向本局提出。申請人向本局提交任何個人資料前，必須已獲得 資料當事人之同意及向其提供第 8/2005 號法律《個人資料保護法》第 10 條第 1 款規定的資訊。</li>" +
    "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。而為處理有關申請，交通事務局與相關行政當局（包括內地、香港、澳門的相關行政當局）可根據第 8/2005 號法律《個人資料保護法》的規定，以包括資料互聯在內的 任何方式，互相提供、交換、確認及使用涉及利害關係人的車輛、車主及駕駛員等的個人資料。</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  3. 免責聲明" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
    "  <li>本網站會適時為本系統項目之監管運作優化進行使用規章更新，為確保所得訊息及時，請留意本網站的最新公告。</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  4. 私隱條款" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>申請者及使用者於本系統所輸入之個人資料只會用於本系統及列印在倘有的電子收據上。</li>" +
    "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  5. 使用條款的改變" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  6. 聯絡方法" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
    "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
    "  <li>交通事務專線：(853) 8866 6363</li>" +
    "  <li>電郵：info@dsat.gov.mo</li>" +
    "</ul>",
    terms_hzmbG_cancel:
      "<ul>" +
      "  <li>進入【香港貨車-停泊澳門跨境貨物轉運站】模塊，點擊【取消】模塊，勾選同意使用規章，便可進入服務頁面。</li>" +
      "  <li>輸入身份驗證信息，可通過澳門批准編號或香港車輛登記號碼驗證；選擇登記類型，可選擇以個人作登記或以公司/單位作登記；輸入本澳流動電話，獲取並輸入驗證碼後，便可提交驗證。</li>" +
      "  <li>驗證通過後便可進入信息確認頁面，申請信息中顯示顯示車輛的澳門批准編號、香港車輛登記號碼、車身底盤號碼及流動電話，不可編輯。</li>" +
      "  <li>輸入取消原因，並勾選注意事項，點擊“確認提交”便可提交申請。</li>" +
      "</ul>",
    Vcode: {
      title: "安全驗證",
      successText: "驗證通過",
      failText: "驗證失敗，請重試",
      sliderText: "拖動滑塊完成拼圖",
      success: "驗證通過",
    },
  },
  hzmbGInsurance: {
    label: {
      noticePhone: "流動電話(用於短訊通知)",
      admittanceStartDate: "允許駛入澳門開始日期",
      admittanceEndDate: "允許駛入澳門結束日期",
      registrationType: "香港車輛類型",
      identificationNo: "香港底盤號碼",
      mainlandInsuranceNo: "保險單編號",
      mainlandInsuranceStartDate: "保險單生效日期",
      mainlandInsuranceEndDate: "保險單結束日期",
    },
    title: {
      boxTitle1: "澳門保險資料",
    },
    message: {
      noChinese: "只可填寫英文字母，数字，字符",
    },
  },
};
